import { RequestPersonsByGroup } from "../dtos/person";
import Server from "./index";

export default class PersonServer extends Server {
  constructor() {
    super("/person.php");
  }

  public get(params: RequestPersonsByGroup): Promise<any> {
    return super.get(params);
  }
}
